<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Create New Assignment'"
  (nzOnCancel)="onCancelClick()"
>
  <ng-container *nzModalContent>
    <nz-progress [nzPercent]="currentProgress()" nzStrokeColor="#1890ff"></nz-progress>
    <div [@stepTransition]="currentStepIndex()" class="modal-content">
      @switch (currentStepIndex()) {
        @case (0) {
          <div class="step-content vertical">
            <h3 class="is-required">1. What are your assignments start and end dates? (Must be within 3 months)</h3>
            <app-date-range-selector
              [startDate]="dateRange?.startDate"
              [endDate]="dateRange?.endDate"
              (startOrEndChange)="onStartOrEndChange($event)"
              (rangeChange)="onDateRangeChange($event)"
              [disabledAfter]="disabledAfter()"
              [showAllTimeButton]="false"
            />

            <nz-divider nzPlain nzText="or"></nz-divider>

            <div class="horizontal">
              <button
                class="center fit-content"
                nz-button
                nzType="default"
                [nzLoading]="isLoading()"
                (click)="onInOneWeekClick()"
              >
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">date_range</span>
                In One Week
              </button>

              <button
                class="center fit-content"
                nz-button
                nzType="default"
                [nzLoading]="isLoading()"
                (click)="onInOneMonthClick()"
              >
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">date_range</span>
                In One Month
              </button>
            </div>
          </div>
        }
        @case (1) {
          <div class="step-content vertical">
            <h3 class="is-required">2. What's the name of your event? (e.g. Onboarding)</h3>
            <input [(ngModel)]="leaderboardName" nz-input [placeholder]="'Event Name'" nzSize="large" />

            <nz-divider nzPlain nzText="or"></nz-divider>

            <div class="horizontal">
              <button
                class="center fit-content"
                nz-button
                nzType="default"
                [nzLoading]="isLoading()"
                (click)="onOnboardingClick()"
              >
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">notes</span>
                Onboarding
              </button>
            </div>
          </div>
        }
        @case (2) {
          <div class="step-content vertical">
            <h3>3. Which scenarios would you like to assign?</h3>
            <div class="grid-content">
              @for (selectableItem of selectableSessionTemplateList(); track $index) {
                <app-session-template-card
                  (click)="onSessionTemplateCardClick(selectableItem)"
                  [sessionTemplate]="selectableItem.item"
                  [selectable]="true"
                  [isSelected]="selectableItem.isSelected"
                ></app-session-template-card>
              }
            </div>
          </div>
        }
        @case (3) {
          <div class="step-content vertical">
            <h3>4. Who would you like to assign to?</h3>
            <div class="grid-content">
              @for (selectableItem of selectableUserList(); track $index) {
                <app-board-vertical-icon-title
                  [selectable]="true"
                  (click)="onUserClick(selectableItem)"
                  [board]="selectableItem.item"
                  [isSelected]="selectableItem.isSelected"
                ></app-board-vertical-icon-title>
              }
            </div>
          </div>
        }
        @default {
          <div class="step-content vertical">
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          </div>
        }
      }
    </div>
  </ng-container>

  <div *nzModalFooter class="horizontal seperate full-width">
    <button nz-button nzType="default" [nzLoading]="isLoading()" (click)="onCancelClick()">Cancel</button>

    <div class="horizontal">
      @if (currentStepIndex() < totalSteps - 1) {
        <button
          nz-button
          nzType="default"
          [nzLoading]="isLoading()"
          [disabled]="currentStepIndex() === 0"
          (click)="onPreviousClick()"
        >
          Previous
        </button>
        <button nz-button nzType="primary" [nzLoading]="isLoading()" (click)="onNextClick()">Next</button>
      } @else if (currentStepIndex() === totalSteps - 1) {
        <button
          nz-button
          nzType="default"
          [nzLoading]="isLoading()"
          [disabled]="currentStepIndex() === 0"
          (click)="onPreviousClick()"
        >
          Previous
        </button>
        <button nz-button nzType="primary" [nzLoading]="isLoading()" (click)="onAddTaskClick()">Create</button>
      }
    </div>
  </div>
</nz-modal>
